<template>
  <v-sheet class="basicConfigurator">
    <v-row class="header">
      <v-col>
        <h1 class="display-1">{{ title }}</h1>
      </v-col>
      <v-col>
        <v-row>
          <v-spacer/>
          <v-col cols="auto">
            <v-btn v-if="showBuyButton" :disabled="adding" :loading="adding" class="buyButtonTop" color="primary" right @click="addToBasket">
              <v-icon>{{ basketProductSubmission && basketProductSubmission.editing ? "save" : "add_shopping_cart" }}</v-icon>
              {{ buyButtonText }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <slot/>
    <v-row class="actionButtons" justify="center">
      <v-col cols="auto">
        <v-btn v-if="showBuyButton" :disabled="adding" :loading="adding" class="actionButton" color="primary" @click="addToBasket">
          <v-icon>{{ basketProductSubmission && basketProductSubmission.editing ? "save" : "add_shopping_cart" }}</v-icon>
          {{ buyButtonText }}
        </v-btn>
      </v-col>
    </v-row>

  </v-sheet>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import {ConfiguredImageDto, ProductDto} from "@swagger";
import {ConfigurationChoices} from '@/global/ProductConfigurationPrefill';
import ImageSelector from "@/components/product-configuration/ImageSelector.vue";

@Component({
  components: {
    ImageSelector,
    ImageBatchSelector: () => import("@/components/product-configuration/ImageBatchSelector.vue")
  }
})
export default class BasicConfigurator extends BasicComponent {

  @Prop(Array) value: ConfiguredImageDto[][]; // Multiple products can be configured at once, an image array for each
  @Prop(Object) product: ProductDto;
  @Prop(Object) choices: ConfigurationChoices;
  @Prop(Boolean) configurationValid: boolean; // Whether the product may be added to the basket


  adding = false;

  get showBuyButton(): boolean {
    return this.configurationValid;
  }

  get title(): string {
    return this.$t("CONFIGURATOR_TITLE").toString().replace("{name}", this.product.name);
  }

  get buyButtonText(): string {
    if (this.basketProductSubmission?.editing) {
      return this.$t("BASKET_SAVE_CONFIGURATION").toString();
    }
    if (this.value.length > 1) {
      return this.$t("BUTTON_ADD_MULTIPLE_TO_BASKET").toString().replace("{amount}", this.value.length.toString());
    }
    return this.$t("BUTTON_ADD_TO_BASKET").toString();
  }

  async addToBasket(): Promise<void> {
    if (this.adding) return;
    this.adding = true;
    await this.addConfiguredProducts(this.value.map(images => ({
          productId: this.product.id,
          images, detailedConfiguration: false
        })), items => this.$emit('addedToBasket', items),
        error => this.$emit('error', error), this.value.map(() => this.choices));
    this.adding = false;
  }

}

</script>
<style lang="scss" scoped>
.basicConfigurator {
  padding: 30px;
  max-height: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;

  .header {
    margin-bottom: 10px;
  }

  @media screen and (max-width: 599px) {
    padding: 16px;

    .header {
      padding-right: 32px;

      h1 {
        font-size: 24px !important;
        line-height: 1.3;
      }
    }
  }
}

.buyButtonTop {
  margin-top: 5px;
  margin-right: 5px;
}
</style>
<style lang="scss">
.actionButtons {
  width: 100%;
  position: absolute;
  bottom: 20px;
  z-index: 12;

  .col {
    padding: 8px;
  }
}
</style>
